import styled from 'styled-components';
import { NavLink as NavLinkFromReactRouter } from 'react-router-dom';
import { Cell } from 'styled-css-grid';

import { ScrollbarStyle, colors } from '@crm-framework/theme';
import { Skeleton } from '@crm-framework/skeleton';

export const ACTIVE_MENU_CLASS = 'leads-active-menu';

export const DrawerHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 50px;
  padding: 0 20px;
  background: #fff;
`;

export const LeadContent = styled(Cell)``;

/* AVATAR */
export const AvatarWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 15px 10px 0 10px;
  color: ${colors.WHITE};
`;

export const DisplayedName = styled.h3`
  width: fit-content;
  font-size: 1.3em;
  font-weight: 600;
  margin: 0;
`;

/* MENU */
export const MenuWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 10px;
  color: ${colors.WHITE};
  background-color: ${colors.SECONDARY};
  overflow-y: auto;
  overflow-x: hidden;

  ${ScrollbarStyle}
`;

export const MenuSubtitle = styled.div`
  width: 100%;
  text-transform: uppercase;
  font-size: 16px;
  color: ${colors.WHITE};
  margin-left: 10px;
  margin-top: 30px;
  margin-bottom: 15px;
`;

export const NavLink = styled(NavLinkFromReactRouter)`
  &.${ACTIVE_MENU_CLASS} {
    background: ${colors.PRIMARY_HOVER};
  }
`;

export const LinkTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 2% 10%;

  :hover {
    background-color: #0847a6;
  }
`;

export const HistoryWrapper = styled.div`
  margin-left: 10px;
  position: relative;
`;

export const HistoryVerticalLine = styled.div`
  border-right: 2px solid white;
  left: 16px;
  position: absolute;
  top: 0;
  height: 100%;
`;

export const HistorySkeletonLine = styled(Skeleton)`
  position: absolute;
  left: 16px;
  top: 0;
  height: 100%;
`;

export const HistoryList = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;
`;

export const HistoryListItem = styled.li`
  margin-bottom: 8px;
`;

export const HistoryListItemWrapper = styled.div`
  align-items: center;
  display: flex;
`;

export const HistoryTitle = styled.div`
  margin-left: 16px;
  width: fit-content;
  flex: 1;
`;
export const HistoryDescription = styled.div`
  cursor: help;
  margin-left: 48px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const TagsWrapper = styled.div`
  margin-left: 10px;
  display: flex;
  flex-wrap: wrap;

  & > * {
    margin-right: 5px;
    margin-bottom: 5px;
  }
`;

export const BasicDataWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin: 30px 0px 0px 10px;
`;
export const BasicDataPosition = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;
